module.exports = __webpack_public_path__ + "media/images/home-mobile-8978de9cd1acf204ca8e995743edf0ff.jpg";